import axios from 'axios';
// import router from '../router';
import store from '../store';

/* eslint no-underscore-dangle: 0 */
// const api = axios.create({
//   baseURL: 'https://soonforward.azurewebsites.net/',
// });

// api.interceptors.request.use((request) => {
//   const newRequest = request;
//   console.log('Starting Request', request);
//   const token = localStorage.getItem('access');
//   if (token) {
//     newRequest.headers.Authorization = `Bearer: ${token}`;
//   }
//   return newRequest;
// });

const api = (() => {
  const getAuthToken = async () => {
    let token = null;
    try {
      token = `Bearer: ${await localStorage.getItem('access')}`;
    } catch (err) {
      console.log('getAuthToken', err);
    }
    return token;
  };

  const instance = axios.create({
    baseURL: 'https://soonforward-backend-f9gpb4e9drejbmd4.eastus2-01.azurewebsites.net/',
  });

  instance.interceptors.request.use(async (config) => {
    console.log('Starting Request', config);
    const newconfig = config;
    newconfig.headers.Authorization = await getAuthToken();
    return newconfig;
  });

  return instance;
})();

// api.interceptors.response.use((response) => {
//   console.log('Response:', response);
//   return response;
// }, async (error) => {
//   const originalRequest = error.config;
//   if (error.response.status === 401 && originalRequest.url.includes('/refreshtoken')) {
//     store.commit('deAuthenticate');
//     router.push('/login');
//     return Promise.reject(error);
//   }
//   if (error.response.status === 401 && !originalRequest._retry
//     && !originalRequest.url.includes('/login')) {
//     originalRequest._retry = true;
//     try {
//       await api.post('/refreshtoken', {
//         data: {
//           refreshToken: localStorage.getItem('refresh'),
//         },
//       }).then((response) => {
//         if (response.status === 200) {
//           localStorage.access = response.data.result;
//         }
//       });
//     } catch (err) {
//       console.log(err);
//     }
//     return api(originalRequest);
//   }
//   return Promise.reject(error);
// });

api.interceptors.response.use((response) => {
  console.log('Response:', response);
  return response;
}, async (error) => {
  if (error.response.status === 401) {
    store.commit('deAuthenticate');
    this.$router.push('/');
    return Promise.reject(error);
  }
  return Promise.reject(error);
});

export default api;
